export const GOOGLE_PASSKEY_ICON = 'google_password_manager';
export const APPLE_PASSKEY_ICON = 'icon_apple_logo';

export const resolvePasskeyProviderIcon = (providerName?: string): string => {
  const name = (providerName ?? '').toLowerCase();
  if (name.includes('samsung') || name.includes('google')) {
    return GOOGLE_PASSKEY_ICON;
  }
  return APPLE_PASSKEY_ICON;
};

const PASSKEY_TOKEN_HEADER = 'x-passkey-token';

const normalizeHeaderValue = (value: unknown): string => {
  if (Array.isArray(value)) {
    return typeof value[0] === 'string' ? value[0] : '';
  }
  return typeof value === 'string' ? value : '';
};

export const getPasskeyToken = (headers?: any): string => {
  if (!headers) {
    return '';
  }
  if (typeof headers.get === 'function') {
    const fromGet = normalizeHeaderValue(
      headers.get(PASSKEY_TOKEN_HEADER) || headers.get('X-Passkey-Token')
    );
    if (fromGet) {
      return fromGet;
    }
  }
  const plain =
    typeof headers.toJSON === 'function' ? headers.toJSON() : headers;
  if (plain && typeof plain === 'object') {
    const match = Object.keys(plain).find(
      (key) => key.toLowerCase() === PASSKEY_TOKEN_HEADER
    );
    if (match) {
      return normalizeHeaderValue(plain[match]);
    }
  }
  return '';
};

const getPasskeyOtpMessage = (response: any): string => {
  if (typeof response === 'string') {
    return response;
  }
  if (typeof response?.data === 'string') {
    return response.data;
  }
  if (typeof response?.response?.data === 'string') {
    return response.response.data;
  }
  if (
    typeof response?.message === 'string' &&
    response.message.toLowerCase().includes('otp flow required')
  ) {
    return response.message;
  }
  return String(
    response?.detail ??
      response?.data?.message ??
      response?.response?.data?.message ??
      response?.error?.msg ??
      ''
  );
};

export const getPasskeyOtpStepUp = (
  response: any
): { required: boolean; passkeyToken: string } => {
  const headers =
    response?.headers ??
    response?.data?.headers ??
    response?.response?.headers;
  const passkeyToken =
    (typeof response?.passkeyToken === 'string' ? response.passkeyToken : '') ||
    getPasskeyToken(headers);
  const status =
    response?.status ??
    response?.statusCode ??
    response?.response?.status;
  const required =
    (status === 412 || status === '412') &&
    (getPasskeyOtpMessage(response).toLowerCase().includes('otp flow required') ||
      Boolean(passkeyToken));
  return { required, passkeyToken };
};

export const isPasskeyOtpRequired = (response: any): boolean =>
  getPasskeyOtpStepUp(response).required;

export const formatPasskeyTimestamp = (iso?: string): string => {
  if (!iso) {
    return '';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return iso;
  }
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
};
